<script lang="ts">
  import { onMount, type Snippet } from 'svelte';

  const {
    children,
  }: {
    children: Snippet;
  } = $props();

  let dialog = $state<HTMLDialogElement | undefined>();
  let open = $state(false);

  $effect.pre(() => {
    open = true;
  });

  onMount(() => {
    dialog?.showModal();
  });
</script>

{#if open}
  <dialog
    bind:this={dialog}
    onclose={() => (open = false)}
    class="bg-base fixed m-auto flex w-[960px] max-w-[90vw] items-center justify-center overscroll-contain
      border-none p-8 shadow-[0_0_0_100vmax_rgba(0,0,0,.4)]"
  >
    <button
      class="bg-white-1000 align-center absolute top-2 right-2 z-20 flex justify-center rounded-full p-2"
      onclick={() => {
        open = false;
      }}
    >
      <svg width="24" height="24" class="fill-black-1000">
        <title>Sluiten</title>
        <use xlink:href="/svg-sprite/sprite.svg#cross-normal"></use>
      </svg>
    </button>
    {@render children()}
  </dialog>
{/if}
